 // dev: "/api/", // 开发环境
export default {
    baseUrl: {
      dev: "/xy/", // 开发环境
	  changeOrigin: true,
    },
  };


 